<script lang="ts">
    import { onMount } from "svelte";
    import InputQuantity from "../components/InputQuantity.svelte";
    import type { CartProduct, Product } from "../model";
    import { api, cart } from "../stores";

    export let productCart: CartProduct;
    let product: Product;
    let getProduct: boolean = true;
    let lastQuantity = 0;
    let quantity = 0;
    let applicablePromoQty: number = 0;

    onMount(() => {
        quantity = productCart.quantity;
        lastQuantity = productCart.quantity;
        // get product
        $api.getProduct(productCart.uid).then(
            (res) => {
                product = res;
                calculePrice();
                $cart.list.subscribe((list) => {
                    const index = list.findIndex(
                        (e) => e.uid == productCart.uid
                    );
                    if (index >= 0) {
                        applicablePromoQty = list[index].applicablePromoQty;
                        productCart = list[index];
                        quantity = productCart.quantity;
                        lastQuantity = quantity;
                        calculePrice();
                    }
                    getProduct = false;
                });
            },
            (err) => {
                console.error(err);
                getProduct = false;
            }
        );
    });

    function getNewQuantity(e) {
        if (e.detail == null) return;
        quantity = e.detail;

        updateQuantity();
    }

    async function updateQuantity() {
        let diff = quantity - lastQuantity;
        lastQuantity = quantity;
        if (quantity <= 0) {
            $cart.remove(productCart, productCart.quantity);
            return;
        }
        calculePrice();
        if (diff > 0) {
            $cart.add(productCart, diff, productCart.cartType);
        } else if (diff < 0) {
            $cart.remove(productCart, diff * -1);
        }
    }

    function calculePrice(): void {
        let price = Number(product.price) * quantity;
        let discountQty = Number(product.discountPriceQty); // nb of product discounted
        if (discountQty <= 0) {
            discountQty = 0;
        }
        let nbLot = 0;
        applicablePromoQty = 0;
        switch (product.meca) {
            case "meca3": // -X% sur le Xe produit
                let unitPrice = parseFloat(product.price); // unit price
                let percent = parseFloat(product.discountAmount); // percent discount
                let unitPriceDiscounted = (percent * unitPrice) / 100; // unit price discounted

                if (quantity > 0 && discountQty > 0) {
                    nbLot = Math.floor(quantity / discountQty); // nb lot
                } else {
                    nbLot = 0;
                }

                if (applicablePromoQty == -1 || nbLot !== 0) {
                    applicablePromoQty = nbLot;
                }

                price = price - applicablePromoQty * unitPriceDiscounted;
                break;
            // default:
        }
        price = Math.round(price * 100) / 100;
        productCart.price = price.toFixed(2).toString();
        productCart.nbLot = nbLot;
        productCart.applicablePromoQty = applicablePromoQty;
    }
</script>

{#if !getProduct && !product}
    <h1>Erreur lors de la récupération du produit</h1>
{/if}

{#if getProduct}
    <h1>Chargement du produit...</h1>
{/if}
{#if product}
    <div class="product">
        <div class="product-img">
            <img
                src={product.images.length > 0
                    ? product.images[0] + "?g=100x100"
                    : ""}
                alt="Chargement de l'image:{product.name}"
            />
        </div>
        <div class="product-info">
            <h1>{product.name}</h1>

            <InputQuantity {quantity} on:update-quantity={getNewQuantity} />

            <div class="price-infos">
                <div class="final-price txt-black">
                    {Number(product.price).toFixed(2).replace(".", ",")}
                    <sup>€</sup><br />
                </div>
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .product {
        display: flex;
        flex-direction: row;
        width: 100%;

        .product-img {
            height: 5rem;
            width: 30%;
            text-align: center;

            img {
                max-height: 100%;
                width: 100%;
                height: auto;
                object-fit: contain;
            }
        }

        .product-info {
            display: flex;
            flex-direction: column;
            width: 70%;

            .price-infos {
                display: flex;
                flex-direction: row;
                align-self: flex-end;
            }
        }

        .final-price {
            font-family: "Diagramm Bold";
            font-size: 20px;
            letter-spacing: -1px;
        }
    }
</style>
